import validator from 'validator'
import get from 'helpers/get'

export const notEmpty = (error = 'Eingabe erforderlich') => ({
	validate: value => !value ? error : null
})

export const isPrice = (error = 'Geben Sie gültigen Preis') => ({
	validare: value => value && !validator.isFloat(value + '') ? error : null
})

export const multiValidate = validatorsArr => {
	let validationProps = validatorsArr.reduce((outObj, { validate, ...restProps }) => ({ ...outObj, ...restProps }), {})
	const validateFunc = (value, vals) => {
		let notValid = null
		validatorsArr.some(({ validate }) => {
			notValid = validate(value, vals)
			return notValid
		})
		return notValid
	}
	return {
		...validationProps,
		validate: validateFunc
	}
}

/*
	Validates for min less than max.
	Arguments: 'field'(str 'min' or 'max') - type of validating field,
	'oppositeField'(str) - name of opposite field,
	'error'(str) - error message to display when validation failed.
	Returns object of props for form field component.
*/
export const minMaxFields = (field, oppositeField, error = 'Incorrect value') => {
	const validate = (val, vals = {}) => {
		const fieldVal = Number(val)
		const getOppositeVal = () => {
			const compositeFieldName = oppositeField.split('.')
			return compositeFieldName.length ? get(compositeFieldName, vals) : vals[oppositeField]
		}
		const oppositeVal = getOppositeVal() === null ? NaN : Number(getOppositeVal())
		if(isNaN(fieldVal) || isNaN(oppositeVal)) {
			return null
		}
		let out = null
		if(field === 'min' && fieldVal > oppositeVal) {
			out = error
		}
		if(field === 'max' && fieldVal < oppositeVal) {
			out = error
		}
		return out
	}
	return {
		validate,
		validateOnChange: true,
		notify: [oppositeField]
	}
}

export const minMaxVal = ({ min: minVal = 0, max: maxVal, error = `Value must be between ${minVal} and ${maxVal}`, setErrorState }) => {
	const min = Number(minVal)
	const max = Number(maxVal)
	if(isNaN(min) || isNaN(max)) {
		return {}
	}
	const validate = value => {
		const val = Number(value)
		if(isNaN(val)) {
			return null
		}
		if(val < min || val > max) {
			setErrorState && setErrorState(true)
			return error
		}
		setErrorState && setErrorState(false)
		return null
	}
	return {
		validate,
		validateOnChange: true
	}
}

export const notNegative = (error = 'Value can not be negative') => ({
	validate: val => val < 0 ? error : null,
	validateOnChange: true
})

export const validateIp = t => (portelIp) => {
	const isIpValid = /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/
	if(!isIpValid.test(portelIp)) {
		return t('validators.not_a_valid_ip_address')
	}
	return null
}
